<div class="filter-chips-container">
    <div class="chips">
        <div *ngFor="let chip of chips" class="chip">
            <span class="chip-filter-text">{{chip.displayName}}</span> <mat-icon (click)="removeFilter(chip)" *ngIf="chip.type !== 'school'">close</mat-icon>
        </div>
    </div>
</div>